import { render, staticRenderFns } from "./BankAccType.vue?vue&type=template&id=1086da41&lang=pug"
import script from "./BankAccType.vue?vue&type=script&lang=js"
export * from "./BankAccType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports